<ng-container *ngIf="folders$ | async as folders">
    <mat-dialog-content class="mat-typography">
        <h2 mat-dialog-title>Séléctionnez un dossier de destination</h2>
        <small *ngIf="folders.length > 0">(Si le nom de dossier saisi n'apparait pas dans la liste il sera automatiquement crée)</small>
        <form [formGroup]="form" >
            <mat-form-field>
                    <mat-label>Sélectionnez un dossier</mat-label>
                        <input type="text" placeholder="Choisissez une option" matInput formControlName="folder"
                            [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="autocompleteDisplayFunction">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{option.label}}
                            </mat-option>
                        </mat-autocomplete>
            </mat-form-field>
            <span *ngIf="folders.length === 0">Vous n'avez pas encore de dossiers, saisissez un nom de dossier à créer ci-dessus</span>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button mat-dialog-close>Annuler</button>
        <button mat-raised-button color="primary" role="submit" (click)="selectOrAddFolderAndGoToAddConnectorPage()">
            <span class="align-items-row">
                &nbsp;Valider
            </span>
        </button>
    </mat-dialog-actions>
</ng-container>
